import { useClient } from '@composables/use-clients';
import {
  PostRequestArgsType,
  PutRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostAgentChatMessagePayloadType = {
  content: string;
};

export type PutAgentChatMessagePayloadType = {
  content: string;
};

type PostAgentChatMessageArgsType = (
  PostRequestArgsType<PostAgentChatMessagePayloadType> & {
    agentChatId: string;
  }
);

type PutAgentChatMessageArgsType = (
  PutRequestArgsType<PutAgentChatMessagePayloadType> & {
    agentChatId: string;
    agentChatMessageId: number;
  }
);

export const apiCreateAgentChatMessage = async ({
  domain = useTenantStore().domain,
  payload,
  agentChatId,
  errorConfig = {},
  callbacks = {},
}: PostAgentChatMessageArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.agentChatMessages({ domain, agentChatId }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateAgentChatMessage = async ({
  domain = useTenantStore().domain,
  payload,
  agentChatId,
  agentChatMessageId,
  errorConfig = {},
  callbacks = {},
}: PutAgentChatMessageArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.agentChatMessages({
        domain,
        agentChatId,
        agentChatMessageId,
      }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
